module.exports = __webpack_public_path__ + "static/media/chat_button_icon.50ae1820.svg";